import { createFileRoute, notFound } from "@tanstack/react-router";
import { getPage } from "@/content/pages";
import { MarkdownPage } from "@/components/MarkdownPage";
import ServiceSoftwareImage from "@/assets/service-software.jpg";
import { pageMetaTitle, metaDescription } from "@/lib/seo";

const PAGE_KEY = "/software-development";

export const Route = createFileRoute("/software-development")({
  loader: () => {
    const page = getPage(PAGE_KEY);
    if (!page) throw notFound();
    return page;
  },
  head: ({ loaderData }) => ({
    meta: loaderData
      ? [
          { title: pageMetaTitle(PAGE_KEY, loaderData.title) },
          { name: "description", content: metaDescription(loaderData.description) },
          { property: "og:title", content: pageMetaTitle(PAGE_KEY, loaderData.title) },
          { property: "og:description", content: metaDescription(loaderData.description) },
          { property: "og:url", content: "https://www.phil-carr.co.uk/software-development" },
        ]
      : [],
    links: [{ rel: "canonical", href: "https://www.phil-carr.co.uk/software-development" }],
  }),
  notFoundComponent: () => (
    <div className="container mx-auto max-w-3xl px-6 py-24 text-center">
      <h1 className="font-display text-4xl">Page not found</h1>
    </div>
  ),
  errorComponent: ({ error }) => (
    <div className="container mx-auto max-w-3xl px-6 py-24 text-center">
      <h1 className="font-display text-3xl">Something went wrong</h1>
      <p className="mt-3 text-muted-foreground">{error.message}</p>
    </div>
  ),
  component: Page,
});

function Page() {
  const page = Route.useLoaderData();
  return (
    <MarkdownPage
      body={page.body}
      pageContext={page.title}
      heroImage={{
        src: ServiceSoftwareImage,
        alt: "Hands typing on a backlit keyboard with monitors in the background",
      }}
      relatedSlugs={[
        "building-a-website-that-supports-seo-and-business-growth",
        "why-seo-starts-with-your-website-and-always-will",
        "data-driven-decisions-leveraging-ga4-for-seo-success",
      ]}
    />
  );
}
